import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Image
} from 'react-bootstrap';
import "./BannerTarjeta.css";
import Translate from "../../../../../../../translate";
import PlanetImage from "../../../../../img/BannerTarjeta_Planeta.png";
import CreditCard from "../../../../../img/wb-banner-definitive.svg";
import CreditCardMobile from "../../../../../img/wb-banner-definitive.svg";
import CreditCardEnglish from "../../../../../img/wb-banner-definitive-english.svg";
import CreditCardMobileEnglish from "../../../../../img/wb-banner-definitive-english.svg";

const BannerTarjeta = ({lan}) => {

  return (
    <div className='comisiones-outter'>
      <div className="ilustration">
        <Image src={PlanetImage} className="planet-card" />
        <Image src={lan === 'es' ? CreditCard : CreditCardEnglish} className="credit-card"/>
        <Image src={lan === 'es' ? CreditCardMobile : CreditCardMobileEnglish} className="credit-card-mobile"/>
      </div>
      <Container>
        <Row>
          <Col xl={6} lg={6} className="center-text-mobile">
            <p>
              <span className="title-card">{Translate[lan].landing3.banner.tarjeta.titulo}</span>
              <br/>
              <span className="subtitle-card">
                {Translate[lan].landing3.banner.tarjeta.subtitulo}
              </span>
            </p>
            <div className="center-btn-mobile">
              <Button className='btn-req-card' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{Translate[lan].landing3.banner.button2}</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default BannerTarjeta